import { useAtomValue } from 'jotai';
import { FC, useCallback } from 'react';
import { LineChart } from '../../../../components/Charts/LineChart/LineChart';
import { IMetricsDataModel } from '../../../../data-models/metrics.data-model';
import { fundsByIdMapAtom } from '../../../../services/state/AppConfigStateJ';
import { CHART_COMPONENTS } from '../../../../types';
import { GroupExtractorFn, useIrrByGroup } from '../../hooks/useIrrByGroup';
import { IPortfolioChartProps } from './ChartComponent';

export const IrrByFundChart: FC<IPortfolioChartProps<IMetricsDataModel>> = (props) => {
  const fundsMap = useAtomValue(fundsByIdMapAtom);
  const transactionFundExtractor = useCallback<GroupExtractorFn>(
    ({ transaction }) => fundsMap.get(transaction.fundId ?? -1)?.name ?? 'Unknown',
    [fundsMap]
  );
  const { data } = useIrrByGroup(props.filteredMetrics, transactionFundExtractor);
  const yFormatter = useCallback((tick: string | number) => `${Number(tick).toFixed(1)}%`, []);

  return (
    <LineChart
      yAxisLabelFormatter={yFormatter}
      data={data}
      id={CHART_COMPONENTS.IRR_BY_FUND}
      title={'IRR by Fund'}
      width={640}
      isFullScreen={props.isFullScreen}
      onOpenFullScreen={props.onOpenFullScreen}
    />
  );
};
